import React from 'react';
import Dropdown from '@/components/ui/therapist/Dropdown';
import { UpdateSettingPayload } from '@/stores/actions/localActions';
import { getFullExerciseName } from '@/utils/exerciseNames';
import { DropdownPositionType } from '@/components/ui/therapist/Dropdown';

interface SpeedDropdownProps {
  updateSettings: (setting: UpdateSettingPayload) => void;
  value: string;
  exerciseName: 'Understanding' | 'Speaking' | 'Writing' | 'Reading';
  setType: 'wordset' | 'sentenceset' | 'textset';
  dropdownPosition?: DropdownPositionType;
}

const SpeedDropdown: React.FC<SpeedDropdownProps> = ({
  updateSettings,
  value,
  exerciseName,
  setType,
  dropdownPosition,
}) => {
  const onSelectChange = (items: string[]) => {
    updateSettings({
      newValue: items[0],
      setType,
      exerciseName: getFullExerciseName(exerciseName, setType),
      fieldToBeUpdated: 'playbackRate',
    });
  };

  const data =
    (exerciseName === 'Understanding' || exerciseName === 'Speaking') &&
    setType === 'textset'
      ? [
          { label: 'langsamer', value: '-2', type: 'legend' },
          { label: '0.75', value: '0.75' },
          { label: '1 (Standard)', value: '1' },
          { label: 'Normalgeschwindigkeit', value: '-1', type: 'test' },
        ]
      : [
          { label: 'langsamer', value: '-2', type: 'legend' },
          { label: '0.5', value: '0.5' },
          { label: '0.75', value: '0.75' },
          { label: '1 (Standard)', value: '1' },
          { label: 'Normalgeschwindigkeit', value: '-1', type: 'test' },
        ];

  return (
    <Dropdown
      allowRemoveItems={false}
      customStyles={{ width: 250, marginTop: 24 }}
      data={data}
      label="Vorsprechgeschwindigkeit"
      onSelectChange={onSelectChange}
      value={[value]}
      dropdownPosition={dropdownPosition}
    />
  );
};

export default SpeedDropdown;
